import PropTypes from 'prop-types';
import * as React from 'react';

const Copy = React.forwardRef(({ color = 'currentColor', size, strokeWidth = 1.2, ...rest }, ref) => {
  const width = size ?? 18;
  const height = size ?? 18;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="M13.5 5.25V3A2.25 2.25 0 0 0 11.25.75H3A2.25 2.25 0 0 0 .75 3v8.25A2.25 2.25 0 0 0 3 13.5h2.25m8.25-8.25H15a2.25 2.25 0 0 1 2.25 2.25V15A2.25 2.25 0 0 1 15 17.25H7.5A2.25 2.25 0 0 1 5.25 15v-1.5m8.25-8.25h-6A2.25 2.25 0 0 0 5.25 7.5v6" />
    </svg>
  );
});

Copy.displayName = 'Copy';

Copy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Copy;
